import { NavLink } from "react-router-dom/cjs/react-router-dom.min"
import { trans } from "../utils"


const CreateButton = ({data,GetModuleData}) => {

    return (<div className="me-4">
        {data.getmodule  == "Ticket" || data.getmodule  == "Extract"  ? "" :
            <NavLink to={`/${data.getmodule}/Add`} className="btn btn-primary font-weight-bolder btn-sm mr-5 p-4">
                <i className="bi bi-plus fs-3"></i> {trans('Create')} {trans(GetModuleData.name_en)}
            </NavLink>
        }
        </div>)
}

export default CreateButton